module.exports = __webpack_public_path__ + "img/deleteAttachment.a29f4f52.gif";